import React from 'react';
import type { CategoryParentOption } from '../categoriesMeta';
import { CategoryFormModalView } from './CategoryFormModalView';
import {
    useCategoryForm,
    type CategoryFormInitialValues,
    type CategoryFormSubmit,
} from './useCategoryForm';

type CategoryFormModalProps = {
    error: string | null;
    initialValues: CategoryFormInitialValues | null;
    isOpen: boolean;
    isSubmitting: boolean;
    mode: 'create' | 'edit';
    onClose: () => void;
    onSubmit: (input: CategoryFormSubmit) => void;
    parentOptions: CategoryParentOption[];
};

/**
 * Container for the Add / Edit Category modal: instantiates the form-state hook
 * and hands its output (plus the modal-chrome props + parent options) to the
 * render-only View.
 */
export const CategoryFormModal: React.FC<CategoryFormModalProps> = ({
    error,
    initialValues,
    isOpen,
    isSubmitting,
    mode,
    onClose,
    onSubmit,
    parentOptions,
}) => {
    const form = useCategoryForm({
        initialValues: initialValues ?? undefined,
        isOpen,
        mode,
        onSubmit,
    });

    return (
        <CategoryFormModalView
            error={error}
            form={form}
            isOpen={isOpen}
            isSubmitting={isSubmitting}
            mode={mode}
            onClose={onClose}
            parentOptions={parentOptions}
        />
    );
};
